import { http } from "@/http";

export default {
    namespaced: true,
    state: {
        phoneNumber: "",
        isOptedIn: false,
        isVerified: false,
        verifiedCount: 0,
        dateVerified: null,
        isPhoneNumberVisible: false,
        isEnterPhoneVisible: false,
        isEnterCodeVisible: false,
        newPhoneNumber: "",
        newCode: "",
        newE164PhoneNumber: ""
    },
    getters: {
        phoneNumber: state => {
            return state.phoneNumber;
        },
        isOptedIn: state => {
            return state.isOptedIn;
        },
        isVerified: state => {
            return state.isVerified;
        },
        verifiedCount: state => {
            return state.verifiedCount;
        },
        dateVerified: state => {
            return state.dateVerified;
        },
        isPhoneNumberVisible: state => {
            return state.isOptedIn
                && state.phoneNumber.length
                && !state.isEnterPhoneVisible
                && !state.isEnterCodeVisible;
        },
        isEnterPhoneVisible: state => {
            return state.isEnterPhoneVisible;
        },
        isEnterCodeVisible: state => {
            return state.isEnterCodeVisible;
        },
        newPhoneNumber: state => {
            return state.newPhoneNumber;
        },
        newE164PhoneNumber: state => {
            return state.newE164PhoneNumber;
        },
        newCode: state => {
            return state.newCode;
        }
    },
    mutations: {
        INCREMENT_VERIFIED_COUNT(state) {
            state.verifiedCount += 1;
        },
        SET_PHONE_NUMBER(state, payload) {
            state.phoneNumber = payload;
        },
        SET_IS_OPTED_IN(state, payload) {
            state.isOptedIn = payload;
        },
        SET_IS_VERIFIED(state, payload) {
            state.isVerified = payload;
        },
        SET_VERIFIED_COUNT(state, payload) {
            state.verifiedCount = payload;
        },
        SET_DATE_VERIFIED(state, payload) {
            state.dateVerified = payload;
        },
        SET_IS_ENTER_PHONE_VISIBLE(state, payload) {
            state.isEnterPhoneVisible = payload;
        },
        SET_IS_ENTER_CODE_VISIBLE(state, payload) {
            state.isEnterCodeVisible = payload;
        },
        SET_NEW_PHONE_NUMBER(state, payload) {
            state.newPhoneNumber = payload;
        },
        SET_NEW_E164_PHONE_NUMBER(state, payload) {
            state.newE164PhoneNumber = payload;
        },
        SET_NEW_CODE(state, payload) {
            state.newCode = payload;
        }
    },
    actions: {
        checkCode({ commit, dispatch }, payload) {
            return http.post("/active-trader/settings/sms/check-code", payload)
                .then(res => {
                    commit("INCREMENT_VERIFIED_COUNT");
                    // TODO: set date_verified to SERVER time (not user PC time)
                    if (res.data.status === "approved") {
                        commit("SET_PHONE_NUMBER", payload.phoneNumber);
                        commit("SET_IS_VERIFIED", true);
                    }

                    return dispatch("saveSmsSettings").then(() => {
                        return res.data.status;
                    })
                })
                .catch(err => {
                    console.error(err.message);
                    throw err;
                });
        },
        fetchSmsSettings({ commit }) {
            return http.get("/active-trader/settings/sms/me")
                .then(res => {
                    commit("SET_PHONE_NUMBER", res.data.phoneNumber);
                    commit("SET_IS_OPTED_IN", res.data.isOptedIn);
                    commit("SET_IS_VERIFIED", res.data.isVerified);
                    commit("SET_VERIFIED_COUNT", res.data.verifiedCount);
                    commit("SET_DATE_VERIFIED", res.data.dateVerified);
                });
        },
        saveSmsSettings({ state }) {
            return http.post("/active-trader/settings/sms/me", {
                phoneNumber: state.phoneNumber,
                isOptedIn: state.isOptedIn,
                isVerified: state.isVerified,
                verifiedCount: state.verifiedCount,
                dateVerified: state.dateVerified
            })
                .then(res => res.data)
                .catch(err => {
                    console.error(err.message);
                    throw err;
                });
        },
        sendCode({ commit, dispatch }, payload) {
            return http.post("/active-trader/settings/sms/send-code", payload)
                .then(() => {
                    commit("INCREMENT_VERIFIED_COUNT");
                    // TODO: set date_verified to SERVER time (not user PC time)
                    return dispatch("saveSmsSettings")
                })
                .catch(err => {
                    console.error(err.message);
                    throw err;
                });
        },
        setIsOptedIn({ commit, dispatch, getters }, payload) {
            dispatch("showBusy", null, { root: true });
            commit('SET_IS_OPTED_IN', payload);
            dispatch("clearNewPhoneNumber");
            dispatch("clearNewE164PhoneNumber");
            dispatch("clearNewCode");
            return dispatch("saveSmsSettings")
                .then(() => {
                    if (getters.isOptedIn && !getters.phoneNumber.length) {
                        dispatch("showEnterPhone");
                    }
                    else {
                        dispatch("hideInputs");
                    }
                }).finally(() => {
                    dispatch("hideBusy", null, { root: true });
                });
        },
        showEnterPhone({ commit }) {
            commit("SET_IS_ENTER_PHONE_VISIBLE", true);
            commit("SET_IS_ENTER_CODE_VISIBLE", false);
        },
        showEnterCode({ commit }) {
            commit("SET_IS_ENTER_PHONE_VISIBLE", false);
            commit("SET_IS_ENTER_CODE_VISIBLE", true);
        },
        hideInputs({ commit }) {
            commit("SET_IS_ENTER_PHONE_VISIBLE", false);
            commit("SET_IS_ENTER_CODE_VISIBLE", false);
        },
        clearNewPhoneNumber({ dispatch }) {
            dispatch("setNewPhoneNumber", "");
        },
        setNewPhoneNumber({ commit }, payload) {
            commit("SET_NEW_PHONE_NUMBER", payload);
        },
        clearNewE164PhoneNumber({ dispatch }) {
            dispatch("setNewE164PhoneNumber", "");
        },
        setNewE164PhoneNumber({ commit }, payload) {
            commit("SET_NEW_E164_PHONE_NUMBER", payload);
        },
        clearNewCode({ dispatch }) {
            dispatch("setNewCode", "");
        },
        setNewCode({ commit }, payload) {
            commit("SET_NEW_CODE", payload);
        }
    }
};